import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContext } from 'react';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { CommentsContext } from '../../../contexts/CommentsContext';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { isCompact } from '../../../types/CommentDensityType';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CommentActionButtons = props => {
  const {
    commentId,
    setShowEditCommentEditor
  } = props;
  const {
    handleDeleteComment,
    onError,
    density
  } = useContext(CommentsContext);
  const buttonSize = isCompact(density) ? 'sm' : 'md';
  const handleDelete = () => {
    handleDeleteComment(commentId).catch(() => {
      onError( /*#__PURE__*/_jsx(FormattedMessage, {
        message: "objectCommentsThread.comments.alerts.deleteError"
      }));
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "objectComments-thread.comments.actionButtons.edit"
      }),
      children: /*#__PURE__*/_jsx(IconButton, {
        "data-test-id": "comments-editButton",
        use: "transparent",
        size: buttonSize,
        onClick: () => setShowEditCommentEditor(true),
        margin: "0",
        padding: "0",
        children: /*#__PURE__*/_jsx(EditIcon, {})
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "objectComments-thread.comments.actionButtons.delete"
      }),
      children: /*#__PURE__*/_jsx(IconButton, {
        "data-test-id": "comments-deleteButton",
        use: "transparent",
        size: buttonSize,
        onClick: () => handleDelete(),
        margin: "0",
        padding: "0",
        children: /*#__PURE__*/_jsx(DeleteIcon, {})
      })
    })]
  });
};